import { render, staticRenderFns } from "./ManageRespondents.vue?vue&type=template&id=c2e8cb4c&scoped=true"
import script from "./ManageRespondents.vue?vue&type=script&lang=js"
export * from "./ManageRespondents.vue?vue&type=script&lang=js"
import style0 from "./ManageRespondents.vue?vue&type=style&index=0&id=c2e8cb4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e8cb4c",
  null
  
)

export default component.exports